module.exports = __webpack_public_path__ + "img/20170704_135648_081.343321c9.jpg";